import { push } from 'react-router-redux';
import Cookies from 'js-cookie';

import forceLogoutHandler from '../users/a.users.forceLogoutHandler';

import {

} from '../actions.export'

////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////
// Get instructions by organization
////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////

export const requestGetInstructionsByOrganization = packet => {
  return {
    type: 'REQUEST_GET_INSTRUCTIONS_BY_ORGANIZATION',
    data: {
      lastSubmit: packet
    }
  }
}

export const receiveGetInstructionsByOrganizationSuccess = data => ({
  type: 'RECEIVE_GET_INSTRUCTIONS_BY_ORGANIZATION_SUCCESS',
  data
})

export const receiveGetInstructionsByOrganizationFail = data => ({
  type: 'RECEIVE_GET_INSTRUCTIONS_BY_ORGANIZATION_FAIL',
  data
})

export const tryToGetInstructionsByOrganization = packet => (dispatch, getState) => {

  dispatch(requestGetInstructionsByOrganization(packet));

  let headers = {
    "Content-Type": "application/json"
  }
  


  let fs = localStorage.getItem(process.env.REACT_APP_COOKIE_FEATURE_SWITCH);
  if(fs){
    headers["X-NFS"] = fs;
  }


  headers["X-CSRF-TOKEN"] = getState().userReducer.csrf_token;
  return fetch('/api/instructions/org/' + packet.org_id, {
      method: 'get',
      headers: headers
    })
    .then((response) => {
      let json = response.json();
      if (response.status >= 200 && response.status < 300) return json;
      return json.then(Promise.reject.bind(Promise));
    })
    .then(function(json){
      dispatch(receiveGetInstructionsByOrganizationSuccess(json));
    })
    .catch(e => {
      dispatch(forceLogoutHandler(e));
      dispatch(receiveGetInstructionsByOrganizationFail({errors:e, lastSubmit: packet}));
    })
}
